require('es6-promise').polyfill();
import axios from 'axios';
import Utilities from './utilities';

export default {
  statusOrder (module_id, order_id, unique_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'order/status' + '/' + module_id + '/' + order_id + '/' + unique_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  statusGateway (module_id, order_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'order/gateway/' + module_id + '/' + order_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
};



// WEBPACK FOOTER //
// ./src/api/order.js